export const isEmpty = (value: unknown): boolean =>
  value === null || value === undefined || value === '';


